import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import withLoader from 'components/organisms/withLoader';
import { format } from 'date-fns';
import { apiCcmPatientManualInteractionTimes } from 'services/dataService/ccmResources';
import Pagination from 'components/molecules/paginationTransition';
import useTable from 'utils/useTable';
import { useParams } from 'react-router-dom';

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:s';
const PER_PAGE = 5;
const CCMManualInteractionTimes = () => {
  const { patientGuid } = useParams();

  const dates = useSelector((state) => state.ccmPatientDetails.dates);

  const {
    data: { items },
    count,
    loading,
    page,
    setPage,
    setFilters,
  } = useTable(apiCcmPatientManualInteractionTimes(patientGuid), PER_PAGE, {
    makeInitialRequest: false,
  });

  useEffect(() => {
    if (dates.length > 1) {
      const startTime = format(dates[0], DATE_FORMAT);
      const endTime = format(dates[1], DATE_FORMAT);
      setFilters({ startTime, endTime });
    }
  }, [dates, patientGuid]);

  return (
    <>
      <h3 className="ccm-table-section__h4">Manual Clinic Notes Logged</h3>
      {withLoader(
        loading,
        <>
          <div className="table-outer table-custom-scrollbar">
            <table cellSpacing="0" cellPadding="0" className="table-border">
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Duration</th>
                  <th>Care Agent</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {!!items.length &&
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {el.date
                          ? format(new Date(el.date), 'LLL dd yyyy p')
                          : ''}
                      </td>
                      <td>{el.timeInMinutes}</td>
                      <td>{el.author}</td>
                      <td>
                        <div className="note">{el.comment}</div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="ccm-table-section__pagination">
            <Pagination
              title=""
              page={page}
              pageTotal={items.length}
              itemsPerPage={PER_PAGE}
              total={count}
              handleFirstClick={() => setPage(1)}
              handleLastClick={() => setPage(Math.ceil(count / PER_PAGE))}
              handlePrevClick={() => setPage(page - 1)}
              handleNextClick={() => setPage(page + 1)}
              handleGoToPage={(numberPage) => setPage(numberPage)}
            />
          </div>
        </>,
      )}
    </>
  );
};

export default CCMManualInteractionTimes;
